/**
 * Fichier isolé pour l'enum `EAuthentificationStep`.
 *
 * Pourquoi : cet enum est utilisé par des modules eager (Redux slice, Backbone
 * `CartModel`, etc.) qui, en l'important depuis `AuthenticationContent.tsx`,
 * tiraient tout le composant d'authentification + ses dépendances
 * (`react-hook-form`, `yup`, `Steps/*`…) dans `app-*.js`.
 *
 * En isolant l'enum dans un fichier sans aucun import, on casse la chaîne
 * et on permet au reste du module `AuthenticationContent` de rester lazy.
 */
export enum EAuthentificationStep {
  SOCIAL_CONNECT = "social-connect",
  SIGN_IN_EMAIL = "sign-in-email",
  RESET_PASSWORD_REQUEST = "reset-password-request",
  RESET_PASSWORD_SUCCESS = "reset-password-success",
  NEW_PASSWORD_REQUEST = "new-password-request",
  NEW_PASSWORD_SUCCESS = "new-password-success",
  SIGN_UP = "sign-up",
  MISSING_FIELDS = "missing-fields",
  LOYALTY_OPT_IN = "loyalty-opt-in",
  LOYALTY_OPT_IN_SUCCESS = "loyalty-opt-in-success",
  DEFAULT = SOCIAL_CONNECT,
}
